import ApiResourceManager from '../ApiResourceManager';

export default class MissedOrderEmailsManager extends ApiResourceManager {
  get = () =>
    this.request({
      method: 'GET',
      url: '/missed-order-emails',
    });

  update = (emails) =>
    this.request({
      method: 'PUT',
      url: '/missed-order-emails',
      data: { emails },
    });
}
